import React from 'react';

import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import { ROW_LAYOUT } from '../constants';

import SortableRegionTaskList, { type SortableRegionTaskListProps } from './sortableRegionTaskList';

// **** Constants **** //

// Exported for tests
export const FORM_TASKS_TABLE_COLUMNS = [
  { name: 'Move' },
  { name: 'Rank' },
  { name: 'Task/Group Name' },
  { name: 'Specify Body Location?' },
  { name: 'Measure Unit' },
  { name: 'Description' },
  { name: 'Modifications' },
  { name: 'Edit' },
] as const;

// **** Types **** //

type FormTasksTableProps = SortableRegionTaskListProps;

// **** Components **** //

/**
 * Default component
 */
const FormTasksTable = ({ dataRows, updateDataRowOrder, onClickEdit }: FormTasksTableProps) => (
  <div>
    <Row widths={[...ROW_LAYOUT]} width="100%">
      {FORM_TASKS_TABLE_COLUMNS.map(({ name }) => (
        <Text key={name} role="columnheader" className="form-tasks-table__text">
          {name}
        </Text>
      ))}
    </Row>
    <SortableRegionTaskList dataRows={dataRows} updateDataRowOrder={updateDataRowOrder} onClickEdit={onClickEdit} />
  </div>
);

// **** Export **** //

export default FormTasksTable;
